import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { activeUser } from "../../services/AuthService";
import Link from "../../common/Link";
import CssLoader from '../../components/cssloader/CssLoader';

export default function AttivaUtentePage() {
    const { id, code } = useParams<{ id: string, code: string }>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const successRedirect = '/';
    const [isMount, setIsMount] = useState<boolean>(false);
    const [hasSuccess, setHasSuccess] = useState<boolean>(false);

    useEffect(() => {
        (async() => {
            if (
                !isMount &&
                id &&
                code
            ) {
                setIsLoading(true);

                await activeUser(id, code).then(() => {
                    setHasSuccess(true);
                }).catch(() => {
                    setHasSuccess(false);
                }).finally(() => {
                    setIsMount(true);
                    setIsLoading(false);
                });
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMount, id, code]);

    if (!isMount) {
        return <></>;
    }

    return <>
        {hasSuccess ? <div>
            <h2>Utente attivato con successo</h2>
            <span>
                <Link href={successRedirect}>
                    Clicca qui
                </Link> per tornare alla home page.
            </span>
        </div> : <div>
            <h2>Errore</h2>
            <span>Si è verificato un errore durante l'attivazione del tuo utente</span>
        </div>}

        <CssLoader active={isLoading} text="Attivazione dell'utente in corso..." /> 
    </>;
}
